
























import { Component, Vue } from 'vue-property-decorator';

/**
 * Dialog for when the currently selected profile is not available for the current project
 * TODO: implement sharing
 */
@Component({
    props: {
        // Media source
        sourceUrl: {
            type: String
        }
    }
})
export default class MediaDetailDialog extends Vue {

    private show = false;
}
